<template>
  <v-dialog
    v-model="isVisible"
    :max-width="maxWidth"
    :persistent="persistent"
    :fullscreen="$vuetify.display.xs && fullscreenOnMobile"
  >
    <KGlassCard class="k-dialog" :class="`k-dialog--${variant}`" :level="3" :padded="false">
      <header class="k-dialog__header">
        <span v-if="icon" class="k-dialog__icon">
          <v-icon :icon="icon" size="20" />
        </span>
        <div class="k-dialog__heading">
          <h2 class="k-dialog__title">{{ title }}</h2>
          <p v-if="subtitle" class="k-dialog__subtitle">{{ subtitle }}</p>
        </div>
        <slot name="header-actions" />
        <v-btn
          v-if="!persistent"
          icon="mdi-close"
          variant="text"
          size="small"
          aria-label="Fermer"
          @click="isVisible = false"
        />
      </header>

      <div class="k-dialog__body">
        <slot />
      </div>

      <footer v-if="$slots.actions" class="k-dialog__actions">
        <slot name="actions" />
      </footer>
    </KGlassCard>
  </v-dialog>
</template>

<script>
import KGlassCard from "@/components/ui/KGlassCard";

export default {
  name: "KDialog",
  components: { KGlassCard },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "default",
      validator: value => ["default", "danger"].includes(value),
    },
    maxWidth: {
      type: [String, Number],
      default: 560,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    fullscreenOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    isVisible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style scoped>
.k-dialog {
  display: flex;
  border-radius: var(--k-radius-lg);
  flex-direction: column;
  max-height: calc(100dvh - 48px);
  overflow: hidden;
}

.k-dialog__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px 12px;
}

.k-dialog__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: var(--k-radius-md);
  color: rgb(var(--v-theme-primary));
  background: color-mix(in srgb, rgb(var(--v-theme-primary)) 14%, transparent);
}

.k-dialog--danger .k-dialog__icon {
  color: rgb(var(--v-theme-error));
  background: color-mix(in srgb, rgb(var(--v-theme-error)) 14%, transparent);
}

.k-dialog__heading {
  flex: 1;
  min-width: 0;
}

.k-dialog__title {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.3;
}

.k-dialog__subtitle {
  margin-top: 2px;
  font-size: 12.5px;
  opacity: 0.7;
}

.k-dialog__body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 20px 16px;
  font-size: 14px;
}

.k-dialog__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px 18px;
  border-top: 1px solid var(--k-glass-border);
}
</style>
